const ACTION_TYPES = ['Create', 'Update', 'Delete', 'Login', 'Support', 'Export'];
const RAW_ACTIONS = ['CREATE', 'UPDATE', 'DELETE', 'LOGIN', 'SUPPORT', 'EXPORT'];

export const auditActorSuggestions = Array.from({ length: 24 }, (_, i) => ({
  id: `usr-plat-${i}`,
  email: `admin${i % 8}@meetinghub.ai`,
  name: `Platform Admin ${i % 8}`,
}));

export const auditLogs = Array.from({ length: 120 }, (_, i) => {
  const actionType = ACTION_TYPES[i % 6];
  const raw = RAW_ACTIONS[i % 6];
  const tenantScoped = i % 3 !== 0;
  const success = i % 19 !== 0;
  return {
    id: `aud-${10000 + i}`,
    eventId: `evt-${20000 + i}`,
    ts: new Date(Date.now() - i * 180000).toISOString(),
    actor: auditActorSuggestions[i % 24].email,
    actorUserId: auditActorSuggestions[i % 24].id,
    scope: tenantScoped ? 'tenant' : 'platform',
    actionType,
    action: raw,
    target: tenantScoped ? `Tenant MH-${String(1000 + (i % 20)).padStart(4, '0')}` : 'Platform config',
    tenantId: tenantScoped ? `tnt-${1100 + (i % 20)}` : null,
    tenantCode: tenantScoped ? `MH-${String(1000 + (i % 20)).padStart(4, '0')}` : null,
    result: success ? 'success' : 'failure',
    ip: `192.168.${i % 255}.${(i * 7) % 255}`,
    userAgent: 'Mozilla/5.0 (MeetingHubAdmin/1.0)',
    fullEvent: {
      id: `evt-${20000 + i}`,
      ts: new Date(Date.now() - i * 180000).toISOString(),
      actor: auditActorSuggestions[i % 24].email,
      action: raw,
      metadata: { requestId: `req-${i}` },
    },
  };
});

export const securityCenterData = {
  staleSecretsCount: 3,
  riskySignIns: 1,
  activeSupportSessions: 2,
  failedMfa24h: 8,
  criticalStaleSecrets: 3,
  secrets: [
    { id: 'sec-1', name: 'Graph webhook signing', ageDays: 210, lastRotatedAt: new Date(Date.now() - 210 * 86400000).toISOString(), status: 'overdue' },
    { id: 'sec-2', name: 'Billing provider HMAC', ageDays: 95, lastRotatedAt: new Date(Date.now() - 95 * 86400000).toISOString(), status: 'due_soon' },
    { id: 'sec-3', name: 'Internal job token', ageDays: 40, lastRotatedAt: new Date(Date.now() - 40 * 86400000).toISOString(), status: 'ok' },
    { id: 'sec-4', name: 'Legacy export key', ageDays: 200, lastRotatedAt: new Date(Date.now() - 200 * 86400000).toISOString(), status: 'overdue' },
  ],
  securityEvents: Array.from({ length: 20 }, (_, i) => ({
    id: `sev-${i}`,
    ts: new Date(Date.now() - i * 3600000).toISOString(),
    type: ['mfa_fail', 'login_anomaly', 'secret_access', 'policy_change'][i % 4],
    actor: `user${i % 5}@mh.ai`,
    result: i % 7 === 0 ? 'failure' : 'success',
    auditRef: `aud-${10100 + i}`,
  })),
  recommendations: [
    { id: 'r1', label: 'Enable MFA for all platform admins', done: false },
    { id: 'r2', label: 'Webhook signatures verified', done: true },
    { id: 'r3', label: 'Rotate overdue API secrets', done: false },
    { id: 'r4', label: 'Restrict support session TTL to 4h', done: true },
  ],
};

export const accessReviewCampaigns = [
  { id: 'camp-q1', name: 'Q1 2025 Platform admin access', status: 'active' },
  { id: 'camp-prev', name: 'FY24 carryover', status: 'archived' },
];

export const accessReviewRowsSeed = Array.from({ length: 18 }, (_, i) => ({
  id: `arr-${i}`,
  campaignId: 'camp-q1',
  userId: `u-${2000 + i}`,
  userName: `Reviewer User ${i + 1}`,
  userEmail: `user${i}@partner.com`,
  role: ['Platform Admin', 'Support Agent', 'Billing Viewer'][i % 3],
  lastUsed: new Date(Date.now() - (i + 1) * 86400000 * 2).toISOString(),
  lastLogin: new Date(Date.now() - (i + 3) * 86400000).toISOString(),
  justification: i % 4 === 0 ? '' : 'Required for tenant onboarding program',
  reviewer: i % 5 === 0 ? null : `lead${i % 3}@meetinghub.ai`,
  decision: i % 7 === 0 ? null : i % 7 === 1 ? 'approve' : i % 7 === 2 ? 'revoke' : 'defer',
  note: '',
}));

/** @deprecated */
export const accessReviews = accessReviewCampaigns;
